import { Link } from "react-router-dom";
import Seo from "@/components/feature/Seo";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import { hotTopics, topicCategories } from "@/mocks/topics";
import RankingList from "./components/RankingList";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "实时热搜榜",
    description:
      "爆点观察局实时热搜榜，汇总全网正在扩散的热门话题，支持按热度、转发量与出圈速度排序。",
    inLanguage: "zh-CN",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "/" },
      { "@type": "ListItem", position: 2, name: "热搜榜", item: "/ranking" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "全网热搜话题排行",
    itemListElement: hotTopics.map((topic, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: topic.title,
      url: `/topic/${topic.id}`,
    })),
  },
];

export default function RankingPage() {
  return (
    <>
      <Seo
        title="实时热搜榜_黑料网爆话题排名_转发量出圈速度一览"
        description="爆点观察局实时热搜榜，汇总全网正在扩散的黑料网爆话题，可按热度、转发量与出圈速度排序，并支持分类筛选与关键词搜索，快速找到被传疯的爆款事件。"
        keywords="热搜榜,黑料网爆热搜,话题转发量,出圈速度,热点话题排行"
        path="/ranking"
        jsonLd={jsonLd}
      />
      <SiteHeader />
      <main>
        <section className="bg-foreground-950 pb-12 pt-28 md:pb-14 md:pt-32">
          <div className="mx-auto w-full max-w-shell px-4 md:px-8">
            <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-background-400">
              <Link to="/" className="transition-colors hover:text-accent-400">
                首页
              </Link>
              <i className="ri-arrow-right-s-line" />
              <span className="text-background-100">热搜榜</span>
            </nav>

            <h1 className="mt-5 font-heading text-3xl font-black text-background-50 md:text-4xl">
              实时热搜榜
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
              这里汇总了全网正在扩散的{" "}
              <strong className="font-medium text-background-50">黑料网爆热搜</strong> 话题。
              每一条都标注了综合热度、累计转发量与当前扩散阶段，你可以按热度、转发量或出圈速度重新排序，也可以直接搜索关键词。
            </p>

            <dl className="mt-8 flex flex-wrap gap-x-10 gap-y-4">
              <div>
                <dt className="text-xs text-background-400">在榜话题</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-background-50">
                  {hotTopics.length} 条
                </dd>
              </div>
              <div>
                <dt className="text-xs text-background-400">覆盖风向</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-background-50">
                  {topicCategories.length - 1} 类
                </dd>
              </div>
              <div>
                <dt className="text-xs text-background-400">榜单刷新</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-background-50">15 分钟</dd>
              </div>
            </dl>
          </div>
        </section>

        <section className="bg-background-50 py-12 md:py-16">
          <div className="mx-auto w-full max-w-shell px-4 md:px-8">
            <RankingList />
          </div>
        </section>
      </main>
      <SiteFooter />
      <ScrollToTop />
    </>
  );
}